import React from "react";
import InfoCard from "../generic/InfoCard";
import CardContainer from "../generic/CardContainer";

interface Props {}

function ContactPage(props: Props) {
  // const {} = props

  return (
    <CardContainer>
      <InfoCard>
        <div className="centered-list-of-stuff">
          <p>
            Email <a href="mailto:curtis.voorhees@gmail.com">curtis.voorhees@gmail.com</a> for questions, booking, validation, etc.
          </p>
        </div>
      </InfoCard>
    </CardContainer>
  );
}

export default ContactPage;
